import { render, staticRenderFns } from "./DirectoryFieldIcon.vue?vue&type=template&id=206539d5&"
import script from "./DirectoryFieldIcon.vue?vue&type=script&lang=js&"
export * from "./DirectoryFieldIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports